"use strict";
//messages.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.infoMessages = exports.successMessage = exports.errorMessages = void 0;
/**
 * Error Messages
 */
exports.errorMessages = {
    unknownError: "An unknown error occurred",
    contactCreationFailed: "Contact creation failed",
    contactFetchFailed: "Contact retrieve failed",
    contactUpdationFailed: "Contact updation failed",
    contactDeletionFailed: "Contact deletion failed",
    contactQueryCreationFailed: "Contact Query creation failed",
    childQueryCreationFailed: "Child Query creation failed",
    childQueryUpdationFailed: "Error while updating child details",
    contactQueryFetchFailed: "contacts Query retrieve failed",
    contactDataNotFound: "Contact data not found",
    contactQueryUpdationFailed: "Contact Query updation failed",
    contactQueryDeletionFailed: "Contact Query deletion failed",
    contactAddressMappingCreationFailed: "Contact Address creation failed",
    companyAddressMappingCreationFailed: "Company Address creation failed",
    addressCreationFailed: "Address creation failed",
    addressFetchFailed: "Address retrieve failed",
    addressUpdationFailed: "Address updation failed",
    addressDeletionFailed: "Address deletion failed",
    addressQueryCreationFailed: "Address Query creation failed",
    addressQueryFetchFailed: "Address Query retrieve failed",
    addressQueryUpdationFailed: "Address Query updation failed",
    addressQueryDeletionFailed: "Address Query deletion failed",
    countryQueryFetchFailed: "Country Query retrieve failed",
    countryFecthFailed: "Country retrieve failed",
    stateQueryFetchFailed: "State Query retrieve failed",
    stateFecthFailed: "State retrieve failed",
    cityFetchFailed: "City retrieve failed",
    cityQueryFetchFailed: "City Query retrieve failed",
    regionFetchFailed: "Region retrieve failed",
    regionQueryFetchFailed: "Region Query retrieve failed",
    contactAddressMappingDeletionFailed: "Contact Address deletion failed",
    companyCreationFailed: "Company creation failed",
    companyFetchFailed: "Company retrieve failed",
    errorinCompanyCreation: "Error in company creation",
    companyUpdationFailed: "Company updation failed",
    companyDeletionFailed: "Company deletion failed",
    companyQueryCreationFailed: "Company Query creation failed",
    companyQueryFetchFailed: "Company Query retrieve failed",
    companyQueryUpdationFailed: "Company Query updation failed",
    companyQueryDeletionFailed: "Company Query deletion failed",
    userNotFound: "User not found",
    emailIdNotEditable: "Email ID cannot be editable",
    invalidCredentials: "Invalid credentials",
    internalServerError: "Internal server error",
    failedToFindUser: "Failed to find user",
    companyNotfound: "Company not found",
    insurerNotFound: "Insurer with the specified ID not found",
    failedToAddInsurer: "Failed to add insurer",
    failedToModifyInsurer: "Failed to modify insurer",
    failedToDeleteInsurer: "Failed to delete insurer",
    failedToSaveAddressMapping: "Failed to save insurer-company address mapping",
    failedToSaveContactMapping: "Failed to save insurer-company contact mapping",
    failedToSaveTpaAddressMapping: "Failed to save tpa-company address mapping",
    failedToSaveBrokerAddressMapping: "Failed to save broker-company address mapping",
    failedToSaveBrokerContactMapping: "Failed to save broker-company contact mapping",
    contactNotFound: "Contact not found",
    failedToFetchInsurers: "Failed to fetch insurers",
    failedToFetchInsurer: "Failed to fetch insurer details",
    failedToAddContact: "Failed to add contact",
    failedToFetchContacts: "Failed to fetch contacts",
    failedToFetchContact: "Failed to fetch contact details",
    failedToModifyBroker: "Failed to modify broker",
    addressIdNotfound: "Address ID not found",
    companyNotFound: "Company not found",
    tpaCompanyNotFound: "Tpa company not found",
    errorInCompanyUpdate: "Error in company updation",
    companyUpdateFailed: "Company updation failed",
    companyCreationForbidden: "Company creation forbidden",
    companyUpdateForbidden: "Company updation forbidden",
    companyDeletionForbidden: "Company deletion forbidden",
    DulicatePanEntry: "Duplicate entry: A company with the same PAN card number already exists.",
    DuplicateTanEntry: "Duplicate entry: A company with the same TAN number already exists.",
    DuplicateGstinEntry: "Duplicate entry: A company with the same GSTIN number already exists.",
    contactCreationForbidden: "Contact creation forbidden",
    contactUpdateForbidden: "Contact updation forbidden",
    companyDetailsNotFound: "Company details not found",
    companyOverallAnalyticsNotFound: "An error occurred while fetching overall company analytics",
    companyAnalyticsNotFound: "An error occurred while fetching company analytics",
    companyIdInvalid: "Invalid company ID",
    contactDocumentMappingCreationFailed: "Error while creating contact document",
    companyListNotFound: "Companies list not found",
    companyListRetrievalFailed: "Companies list retrieval failed",
    insurerCompanyListNotFound: "Insurer company list not found",
    tpaCompanyListNotFound: "Tpa company list not found",
    brokerCompanyListNotFound: "Broker company list not found",
    companyContactMappingCreationFailed: "Error while creating company contact",
    companyContactMappingDeletionFailed: "Error while deletion of company contact",
    insurerContactMappingDeletionFailed: "Error while deletion of insurer company contact",
    tpaContactMappingDeletionFailed: "Error while deletion of tpa company contact",
    brokerContactMappingDeletionFailed: "Error while deletion of broker company contact",
    communicationEmailError: "An error occurred while checking communication email.",
    communicationPhoneError: "An error occurred while checking communication phone number.",
    insurerCreationForbidden: "Insurer creation forbidden",
    brokerNotFound: "Broker not found",
    brokerCreationForbidden: "Broker creation forbidden",
    brokerCreationFailed: "Broker creation failed",
    failedToAddBroker: "Failed to add broker",
    failedToFetchBrokers: "Failed to fetch brokers",
    failedToUpdateBroker: "Failed to update broker",
    failedToDeleteBroker: "Failed to delete broker",
    tpaAddressIdNotFound: "TPA address ID not found",
    tpaAddressForbidden: "TPA address deletion forbidden",
    opportunityCreationFailed: "Opportunity creation failed",
    opportunityActivityCreationFailed: "Opportunity activity creation failed",
    opportunityUpdateFailed: "Opportunity update failed",
    opportunityDetailsRetrievalFailed: "Opportunity details retrieval failed",
    opportunityListRetrievalFailed: "Opportunity list retrieval failed",
    opportunityNotFound: "Opportunity not found",
    opportunityDeletionFailed: "Opportunity deletion failed",
    opportunityActivityUpdateFailed: "Opportunity activity update failed",
    companyDocumentError: "Each companyDocMap must have a documentId",
    companyListFailed: "Failed to fetch companies",
    companyAddressFailed: "Failed to update or create address details",
    groupComanyNotFound: "Group company not found",
    groupCompanyCreationFailed: "Group company map creation failed",
    companyDocCreationFailed: "Company document map creation failed",
    companyAddressRequired: "Company address is required",
    fileUploadFailed: "Error at Uploading File",
    fileDeleteFailed: "Error at deleting file",
    fileReplaceFailed: "Error at replacing file",
    fileNotFound: "File not found",
    fileIdRequired: "File ID is required",
    fileRequired: "File is required",
    fileIdNotFound: "File ID not found",
    companyTypeRequired: "Company type is required",
    fileForbidden: "File deletion forbidden",
    groupCompanyListNotFound: "Group company list not found",
    groupCompanyListRetrievalFailed: "Group company list retrieval failed",
    taskCreationFailed: "Task creation failed",
    taskUpdateFailed: "Task update failed",
    taskDetailsRetrievalFailed: "Task details retrieval failed",
    taskNotFound: "Task not found",
    taskWithIdNotFound: (id) => `Task with id ${id} not found`,
    taskDeletionFailed: "Task deletion failed",
    taskCompletionFailed: "Task completion failed",
    invalidTaskType: "Only sub-tasks can be marked complete",
    documentWithIdNotFound: (id) => `Document with id ${id} not found`,
    meetingCreationFailed: "Meeting creation failed",
    taskListRetrievalFailed: "Task list retrieval failed",
    noteCreationFailed: "Failed to create note",
    noteUpdateFailed: "Failed to update note",
    noteDetailsRetrievalFailed: "Failed to retrieve note details",
    noteNotFound: "Note not found",
    noteDeletionFailed: "Failed to delete note",
    noteListRetrievalFailed: "Failed to retrieve note list",
    meetingUpdateFailed: "Meeting update failed",
    meetingDetailsRetrievalFailed: "Meeting details retrieval failed",
    meetingListRetrievalFailed: "Meeting list retrieval failed",
    meetingNotFound: "Meeting not found",
    meetingDeletionFailed: "Meeting deletion failed",
    opportunityActivityMetaNotFound: "Opportunity activity meta not found",
    brokingSlipActivityMetaNotFound: "Broking slip Activity not found",
    brokingSlipVersionsNotFound: "Broking slip versions not found",
    tokenNotFound: "Authorization header is missing",
    noTemplateFound: (policyTypeId) => `No stage-activity templates found for policyTypeId ${policyTypeId}`,
    stageNotFound: (stageId) => `Stage ID ${stageId} not found in stageMap`,
    activityNotFound: (activityId) => `Activity ID ${activityId} not found in activityMap`,
    badRequestWhileActivityMapping: "Bad Request while mapping activities",
    opportunityActivityMetaUpdateFailed: "Opportunity activity meta update failed",
    opportunityNotPresent: (opportunityId) => `Opportunity ID ${opportunityId} not found in opportunityMap`,
    rfpCoverDetailsNotFound: (opportunityId) => `RFP cover details for Opportunity ID ${opportunityId} not found`,
    opportunityActivityNotFound: (opportunityId) => `Opportunity activity for Opportunity ID ${opportunityId} not found`,
    noCoversFoundForOpportunity: (opportunityId) => `No covers found for Opportunity ID ${opportunityId}`,
    premiumCalculationError: "Failed to save premium calculation",
    premiumCalculationDocumentsError: "Failed to save premium calculation documents",
    premiumCalculationRetrieveFailed: "Error retrieving premium calculation details",
    heldCoverNoteError: "Failed to save Held cover note",
    heldCoverNoteDocumentsError: "Failed to save Held cover note documents",
    opportunityHeldCoverNoteRetrieveFailed: "Failed to retrieve Held Cover Note details",
    rfpActivityDetailsNotFound: (opportunityId) => `RFP activity details for Opportunity ID ${opportunityId} not found`,
    rfpActivityDocumentsNotFound: (opportunityId) => `RFP activity documents for Opportunity ID ${opportunityId} not found`,
    policyConfirmationDataFailed: "Failed to create policy confirmation in the database.",
    failedToFetchTasks: "Failed to fetch the Tasks",
    failedToFetchMeetings: "Failed to fetch the Meetings",
    quoteRetrievalFailed: "Quote retrieval failed",
    quoteUpdateFailed: "Quote update failed",
    quoteDeletionFailed: "Quote deletion failed",
    opportunityQuoteNotFound: "Opportunity quote not found",
    policyDocketDataFailed: "Failed to create policy docket",
    policyDocketNotFound: "Policy docket not found",
    policyDocketRetrievalFailed: "Policy docket retrieval failed",
    policyDocketUpdateFailed: "Policy docket update failed",
    opportunityActivitiesRetrieveFailed: "Failed to retrieve opportunity activity details",
    opportunityPolicyConfirmationRetrieveFailed: "Failed to retrieve Policy Confirmation details",
    opportunityPolicyHardCopyRetrieveFailed: "Failed to retrieve opportunity policy hard copy details",
    opportunityPremiumCalculationRetrieveFailed: "Failed to retrieve opportunity premium calculation details",
    heldCoverNoteNotFound: "Held cover note not found",
    heldCoverNoteUpdateFailed: "Held cover note update failed",
    policyConfirmationNotFound: "Policy confirmation not found",
    policyConfirmationUpdateFailed: "Policy confirmation update failed",
    policyHardCopyNotFound: "Policy hard copy not found",
    policyHardCopyUpdateFailed: "Policy hard copy update failed",
    insurerContactsNotFound: "Insurer contacts not found",
    failedToFetchInsurerContacts: "Failed to fetch insurer contacts",
    tpaContactsNotFound: "TPA contacts not found",
    failedToFetchTpaContacts: "Failed to fetch TPA contacts",
    brokerContactsNotFound: "Broker contacts not found",
    failedToFetchBrokerContacts: "Failed to fetch broker contacts",
    brokingSlipDetailsRetrievalFailed: "Broking Slip Version Details retrieval failed",
    brokingSlipVersionDetailsRetrieveFailed: "Error retrieving broking slip version details by opportunity activity ID",
    finalNegotiationActivityCreationFailed: "Failed to create final negotiation activity",
    finalNegotiationActivityUpdateFailed: "Failed to update final negotiation activity",
    finalNegotiationActivityRetrievalFailed: "Failed to retrieve final negotiation activity",
    placementSlipCreationFailed: "Failed to create placement slip",
    placementSlipUpdateFailed: "Failed to update placement slip",
    placementSlipRetrievalFailed: "Failed to retrieve placement slip",
    placementSlipDeletionFailed: "Failed to delete placement slip",
    notificationCreationFailed: "Failed to create notification",
    notificationUpdateFailed: "Failed to update notification",
    notificationRetrievalFailed: "Failed to retrieve notification",
    notificationDeletionFailed: "Failed to delete notification",
    meetingParticipantsRequired: "Meeting participants are required",
    notificationUserRequired: "user_id or email_id is required",
    notificationSendFailed: "failed to send notification",
    quoteComparisonReportCreationFailed: "Failed to create Quote Comparison report in the database.",
    quoteComparisonReportRetrieveFailed: "Failed to retrieve Quote Comparison report",
    quoteComparisonReportUpdateFailed: "Quote Comparison Report update failed",
    quoteComparisonReportNotFound: "Quote Comparison Report not found",
    opportunityCoverNotFound: "Opportunity Cover not found",
    failedToFetchOpportunityContacts: "Failed to fetch opportunity contacts",
    opportunityContactsNotFound: "Opportunity contacts not found",
    issuanceDateBeforeOppportunityCreationDate: "The given issuance date cannot be before or equal to the opportunity creation date.",
    issuanceDateAfterOppportunityExpiryDate: "The given issuance date cannot be after or equal to the opportunity SO expiry date.",
    issuanceDateFormatError: "Invalid issuance date format.",
    premiumCalculationNotFound: "Premium calculation not found.",
    premiumCalculationUpdateFailed: "Failed to update premium calculation.",
    quoteComparisonReportGenerationFailed: "Failed to generate Quote Comparison Report.",
};
/**
 * Success Messages
 */
exports.successMessage = {
    employeeCreation: "Employee created successfully",
    employeeUpdate: "Employee updated successfully",
    employeeDeletion: "Employee deleted successfully",
    employeeRetrieval: "Employee retrieved successfully",
    employeeListRetrieval: "Employees retrieved successfully",
    employeeHierarchyRetrieval: "Employee hierarchy retrieved successfully",
    employeesWithPrivilege: "Employees with privilege retrieved successfully",
    parentWithPrivilege: "User with privilege in hierarchy retrieved successfully",
    contactCreated: "Contact created successfully",
    contactListRetrieved: "Contact List retrieved successfully",
    contactDetails: "Contact retrieved successfully",
    insurerDetails: "Insurer retrieved successfully",
    contactUpdated: "Contact updated successfully",
    contactDeleted: "Contact deleted successfully",
    addressCreated: "Address created successfully",
    addressListRetrieved: "Address list retrieved successfully",
    insurerListRetrieved: "Insurer list retrieved successfully",
    addressDetails: "Address retrieved successfully",
    addressUpdated: "Address updated successfully",
    addressDeleted: "Address deleted successfully",
    countryFecthed: "Country fetched successfully",
    countryListFetched: "Country list fetched successfully",
    stateListFetched: "State list fetched successfully",
    cityListFetched: "City list fetched successfully",
    regionListFetched: "Region list fetched successfully",
    insurerCreated: "Insurer successfully created.",
    insurerListRetrived: "Insurer successfully retrieved.",
    insurerUpdated: "Insurer successfully updated.",
    tpaCreated: "TPA created successfully",
    tpasRetrieved: "TPAs retrieved successfully",
    tpaRetrieved: "TPA retrieved successfully",
    tpaUpdated: "TPA updated successfully",
    tpaDeleted: "TPA deleted successfully",
    companyCreated: "Company created successfully",
    companyListRetrieved: "Company list retrieved successfully",
    insurerCompanyListRetrieved: "Insurer company list retrieved successfully",
    tpaCompanyListRetrieved: "Tpa company list retrieved successfully",
    brokerCompanyListRetrieved: "Broker company list retrieved successfully",
    companyDetails: "Company retrieved successfully",
    companyUpdated: "Company updated successfully",
    companyDeleted: "Company deleted successfully",
    companyAddressCreated: "Company address created successfully",
    companyAddressListRetrieved: "Company address list retrieved successfully",
    companyAddressDetails: "Company address retrieved successfully",
    companyAddressUpdated: "Company address updated successfully",
    userLoggedIn: "User logged in successfully",
    userDetailsRetrieved: "User details retrieved successfully",
    tpaContactCreated: "TPA Contact created successfully",
    tpaContactListRetrieved: "TPA Contact list retrieved successfully",
    tpaContactDetails: "TPA Contact retrieved successfully",
    tpaContactUpdated: "TPA Contact updated successfully",
    tpaContactDeleted: "TPA Contact deleted successfully",
    tpaDetailsRetrieved: "TPA details retrieved successfully",
    contactDetailsRetrieved: "Contact details retrieved successfully for the insurer",
    contactAdded: "Contact added to the insurer successfully",
    insurerRetrievedSuccesfully: "Insurer retrieved successfully",
    insurerDetailsRetrieved: "Insurer details retrieved successfully",
    insurerDeleted: "Insurer deleted successfully",
    companyOverallAnalytics: "Company overall analytics retrieved successfully",
    companyAnalyticsFetched: "Company analytics fetched successfully",
    tpaAddressDeleted: "TPA address deleted successfully",
    brokerCreated: "Broker created successfully",
    brokerListRetrieved: "Broker list retrieved successfully",
    brokerDetails: "Broker retrieved successfully",
    brokerUpdated: "Broker updated successfully",
    brokerDeleted: "Broker deleted successfully",
    brokerDetailsRetrieved: "Broker details retrieved successfully",
    opportunityCreated: "Opportunity created successfully",
    opportunityActivityCreated: "Opportunity activity saved successfully",
    opportunityUpdated: "Opportunity updated successfully",
    opportunityDeleted: "Opportunity deleted successfully",
    brokingSlipVersionDeleted: "Broking Slip Version deleted successfully",
    opportunityListRetrieved: "Opportunities retrieved successfully",
    opportunityDetails: "Opportunity details retrieved successfully",
    opportunityActivityMetaRetrieved: "Opportunity activity meta retrieved successfully",
    opportunityActivityDataRetrieved: "Opportunity activity details retrieved successfully",
    opportunityActivityMetaRetrievalFailed: "Opportunity activity meta retrieval failed",
    tokenRefreshed: "Token refreshed successfully.",
    groupCompanyListRetrieved: "Group company list retrieved successfully",
    taskCreation: "Task created successfully",
    taskUpdation: "Task updated successfully",
    taskDetails: "Task details retrieval successfully",
    taskDeleted: "Task deleted successfully",
    taskCompleted: "Task marked completed successfully",
    taskList: "Task list retrieval successfully",
    noteCreation: "Note created successfully",
    noteUpdate: "Note updated successfully",
    noteDetails: "Note details retrieval successfully",
    noteList: "Note list retrieval successfully",
    noteDeleted: "Note deleted successfully",
    meetingCreation: "Meeting created successfully",
    meetingUpdated: "Meeting updated successfully",
    meetingDetails: "Meeting details retrieval successfully",
    meetingList: "Meeting list retrieval successfully",
    meetingDeleted: "Meeting deleted successfully",
    opportunityActivityUpdatedSuccessfully: "Opportunity activities updated successfully",
    tasksFetched: "Tasks fetched successfully",
    quoteRetrieved: "Quote retrieved successfully",
    quoteUpdated: "Quote updated successfully",
    quoteDeleted: "Quote deleted successfully",
    policyDocketRetrieved: "Policy docket retrieved successfully",
    policyDocketUpdated: "Policy docket updated successfully",
    heldCoverNoteUpdated: "Held Cover Note updated successfully",
    policyConfirmationUpdated: "Policy Confirmation updated successfully",
    policyHardCopyUpdated: "Policy Hard Copy updated successfully",
    insurerContactsRetrieved: " Insurer contacts retrieved successfully",
    tpaContactsRetrieved: "TPA contacts retrieved successfully",
    brokerContactsRetrieved: "Broker contacts retrieved successfully",
    passwordResetMailSent: "Password reset email sent",
    passwordUpdated: "Password updated successfully",
    brokeingSlipVersionsRetrieved: "All Broking Slip Versions retrieved successfully",
    finalNegotiationActivityCreated: "Final negotiation activity created successfully",
    finalNegotiationActivityUpdated: "Final negotiation activity updated successfully",
    finalNegotiationActivityRetrieved: "Final negotiation activity retrieved successfully",
    placementSlipCreated: "Placement slip created successfully",
    placementSlipUpdated: "Placement slip updated successfully",
    placementSlipRetrieved: "Placement slip retrieved successfully",
    placementSlipDeleted: "Placement slip deleted successfully",
    notificationCreated: "Notification created successfully",
    notificationUpdated: "Notification updated successfully",
    notificationRetrieved: "Notification retrieved successfully",
    notificationDeleted: "Notification deleted successfully",
    quoteComparisonReportUpdated: "Quote Comparison Report updated successfully",
    mandateUpdated: "Mandate updated successfully",
    opportunityContactsRetrieved: "Opportunity contacts retrieved successfully",
    premiumCalculationUpdated: "Premium calculation updated successfully.",
};
/**
 * Info Messages
 */
exports.infoMessages = {
    noEmployees: "No employees found",
    employeeNotFound: "Employee not found",
    employeeHierarchyNotFound: "Unable to retrieve hierarchy for the user",
    employeePrivilegeNotFound: "No users with the given privilege found",
    userNotFound: "User not found",
    unknownError: "An unknown error occurred",
    tpaNotFound: "TPA not found",
    contactNotFound: "Contact not found",
    insurerNotFound: "Insurer not found",
    noDataAvailable: "No data available",
    tpaAddressNotFound: "TPA address not found",
    forBidden: "Forbidden",
    employeeUpdateFailed: "Employee update data not found",
    employeeEmailIdAlreadyExists: "Employee email ID already exists",
    employeeIdAlreadyExists: "Employee ID already exists",
    loginNameAlreadyExists: "Login name already exists",
    invalidOrgBranch: "The selected Branch does not exist in the Organisation selected",
    invalidOrgVertical: "The selected SBU does not exist in the Organisation selected",
    invalidOrgVerticalDept: "The selected Department does not exist in the Organisation & Vertical selected",
    invalidReportingManager: "Specified Reporting Manager is invalid",
    reportingMgrInReportees: "Reporting Manager can not also be selected as a Reportee",
    invalidRolesinCreate: "Specified User Roles do no exist",
    missingPrivilegeKeys: "Privilege Keys - Category Key and Action Key - missing in request",
    inactiveUsersInReportees: "Reportee list includes Deleted Users",
    reportingMgrSelf: "Employee can not report to themselves",
    userIdCantChange: "User Id cannot be changed during an update",
    cannotRemoveReportees: "Removing existing reportees is not permitted",
    reportingMgrMissingNotFound: "A valid Reporting Manager must be specified to move current reportees before deleting an employee",
    delegateUserNotFound: "Delegated User to transfer ownership of companies and opportunities not found",
};
